// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1WMgc","validationTips":"StatementDescriptor_validationTips__3G2OJ"};